<template>
  <div style="position: sticky; top: 0; z-index: 100">
    <Notifications />
    <div>
      <div>
        <div class="sticky-buttons">
          <router-link to="/" v-if="$route.name !== 'index'">
            <button
              type="button"
              class="btn btn-secondary btn-circle btn-xl float-left"
            >
              <font-awesome-icon icon="home"></font-awesome-icon>
              
            </button>
          </router-link>
          <a href="/"> </a>
          <router-link to="/" v-if="$route.name === 'cart'">
            <button
              type="button"
              class="btn btn-secondary btn-circle btn-xl float-right"
            >
              <font-awesome-icon icon="arrow-left"></font-awesome-icon>
            </button>
          </router-link>
          <router-link to="/cart" v-if="$route.name !== 'cart'">
            <button
              type="button"
              class="btn btn-secondary btn-circle btn-xl float-right position-relative"
            >
              <font-awesome-icon icon="shopping-cart"></font-awesome-icon>
              <span class="badge badge-danger cart-badge">{{
                cartItemsCount
              }}</span>
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from "../components/Notifications";

export default {
  name: "Header",
  components: {
    Notifications,
  },
  created() {
    this.$store.dispatch("fetchCart", { self: this }).catch((err) => {
      self.$store.commit("addNotification", {
        text: "Chyba načtení položky. " + err.message,
        type: "alert",
      });
    });
  },
  computed: {
    cartItemsCount() {
      let count = 0;
      if (this.$store.state.cart !== undefined) {
        this.$store.state.cart.forEach((element) => {
          count += element.count;
        });
      }
      return count;
    },
  },
};
</script>
